import { useState } from "react";
import { DEFAULT_DATA_QUALITY, loadDataQuality, saveDataQuality } from "../lib/dataQualityFilters";

export default function DataQualityBar({ onChange }) {
  const [filters, setFilters] = useState(() => loadDataQuality());

  function toggle(key) {
    const next = { ...filters, [key]: !filters[key] };
    setFilters(next);
    saveDataQuality(next);
    onChange?.(next);
  }

  const toggles = [
    { key: "excludeInternal", label: "Internal" },
    { key: "excludeTest", label: "Test" },
    { key: "excludeSandbox", label: "Sandbox" },
    { key: "excludeDev", label: "Dev" },
  ];

  return (
    <div className="data-quality-bar">
      <span className="data-quality-bar-label">Calibrate data</span>
      {toggles.map((t) => (
        <label key={t.key} className="data-quality-chip">
          <input type="checkbox" checked={Boolean(filters[t.key])} onChange={() => toggle(t.key)} />
          Exclude {t.label}
        </label>
      ))}
    </div>
  );
}

export { DEFAULT_DATA_QUALITY, loadDataQuality };
